export const statuses = ["ACTIVE", "INACTIVE", "PENDING"];
export const ageGroup = [
  "JUNIOR",
  "YOUTH",
  "UNDER_15",
  "UNDER_16",
  "UNDER_17",
  "UNDER_18",
  "UNDER_19",
  "UNDER_20",
  "UNDER_21",
  "UNDER_22",
  "UNDER_23",
  "SENIOR",
  "MASTERS",
];

export const gender = ["MALE", "FEMALE", "MIXED", "UNKNOWN"];
